"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RangePicker = void 0;
var _react = _interopRequireWildcard(require("react"));
var _datePicker = _interopRequireDefault(require("antd/es/date-picker"));
require("antd/dist/antd.css");
require("./style.sass");
var _classnames = _interopRequireDefault(require("classnames"));
require("moment/locale/ru");
var _ru_RU = _interopRequireDefault(require("antd/lib/locale/ru_RU"));
var _antd2 = require("antd");
var _moment = _interopRequireDefault(require("moment"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();
  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };
  return cache;
}
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache();
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;
  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
var AntRangePicker = _datePicker.default.RangePicker; // eslint-disable-next-line import/prefer-default-export

var RangePicker = function RangePicker(_ref) {
  var _ref2, _ref3, _props$value, _mainRef$current, _mainRef$current$targ, _props$ranges2;
  var minDate = _ref.minDate,
    maxDate = _ref.maxDate,
    _ref$isRangePicker = _ref.isRangePicker,
    isRangePicker = _ref$isRangePicker === void 0 ? true : _ref$isRangePicker,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, ["minDate", "maxDate", "isRangePicker", "className"]);
  var pickerRef = (0, _react.useRef)(null);
  var mainRef = (0, _react.useRef)(null);
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpened = _useState2[0],
    setIsOpened = _useState2[1];
  var _useState3 = (0, _react.useState)(),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedValue = _useState4[0],
    setSelectedValue = _useState4[1];
  var selectorClassName = (0, _classnames.default)(className, 'sber-rangepicker', {
    'sber-datepicker': !isRangePicker
  });
  var panelClassName = (0, _classnames.default)(className, isRangePicker ? 'sber-rangepicker' : 'sber-datepicker');
  var setMomentDate = function setMomentDate(date, period) {
    var start = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    if (!date) return start ? (0, _moment.default)().startOf(period) : (0, _moment.default)().endOf(period);
    if (start) {
      return (0, _moment.default)(date).isBefore((0, _moment.default)().startOf(period)) ? (0, _moment.default)().startOf(period) : (0, _moment.default)(date);
    }
    return (0, _moment.default)(date).isAfter((0, _moment.default)().endOf(period)) ? (0, _moment.default)().endOf(period) : (0, _moment.default)(date);
  };
  var standartRanges = {
    'За неделю': [setMomentDate(minDate, 'week'), setMomentDate(maxDate, 'week', false)],
    'За этот месяц': [setMomentDate(minDate, 'month'), setMomentDate(maxDate, 'month', false)],
    'За этот год': [setMomentDate(minDate, 'year'), setMomentDate(maxDate, 'year', false)],
    'За прошлый год': [(0, _moment.default)().subtract(1, 'year').startOf('year'), (0, _moment.default)().subtract(1, 'year').endOf('year')]
  };
  var ranges = (_ref2 = props.ranges) !== null && _ref2 !== void 0 ? _ref2 : standartRanges; // промежуток заблокированных дат

  var disabledDate = function disabledDate(date) {
    if (maxDate && minDate) return !date.isBetween(minDate, maxDate);
    if (maxDate) return date.isAfter(maxDate);
    if (minDate) return date.isBefore(minDate);
    return false;
  };
  var dropdownClassName = (0, _classnames.default)('sber-rangepicker-dropdown', _defineProperty({}, props.dropdownClassName, props.dropdownClassName));
  var datePickerProps = {
    ref: mainRef,
    dropdownClassName: dropdownClassName,
    onOpenChange: function onOpenChange(open) {
      if (!isOpened) {
        setIsOpened(open);
      }
    },
    className: selectorClassName,
    // eslint-disable-next-line react/display-name
    panelRender: function panelRender(panelNode) {
      var _props$ranges;
      return /*#__PURE__*/_react.default.createElement("span", {
        ref: pickerRef,
        className: "".concat(panelClassName, "-panel")
      }, /*#__PURE__*/_react.default.createElement("span", {
        ref: pickerRef,
        className: (0, _classnames.default)("".concat(panelClassName, "__calendar"), _defineProperty({}, "".concat(panelClassName, "__calendar-ranges"), (_props$ranges = props.ranges) !== null && _props$ranges !== void 0 ? _props$ranges : ranges))
      }, panelNode));
    },
    format: 'DD.MM.YYYY',
    value: (_ref3 = (_props$value = props.value) !== null && _props$value !== void 0 ? _props$value : selectedValue) !== null && _ref3 !== void 0 ? _ref3 : mainRef === null || mainRef === void 0 ? void 0 : (_mainRef$current = mainRef.current) === null || _mainRef$current === void 0 ? void 0 : (_mainRef$current$targ = _mainRef$current.target) === null || _mainRef$current$targ === void 0 ? void 0 : _mainRef$current$targ.value,
    disabledDate: disabledDate
  };
  return /*#__PURE__*/_react.default.createElement(_antd2.ConfigProvider, {
    locale: _ru_RU.default
  }, isRangePicker ? /*#__PURE__*/_react.default.createElement(AntRangePicker, _extends({}, datePickerProps, {
    separator: "|",
    id: "sber-rangepicker",
    dropdownClassName: "sber-rangepicker-dropdown",
    ranges: (_props$ranges2 = props.ranges) !== null && _props$ranges2 !== void 0 ? _props$ranges2 : ranges,
    onChange: function onChange(value) {
      setSelectedValue(value);
      setIsOpened(false);
    }
  }, props)) : /*#__PURE__*/_react.default.createElement(_antd2.DatePicker, _extends({}, datePickerProps, {
    id: "sber-datepicker",
    dropdownClassName: "sber-dropdown" // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    ,

    onChange: function onChange(value) {
      setSelectedValue(value);
      setIsOpened(false);
    }
  }, props)));
};
exports.RangePicker = RangePicker;